const miniCartContainer = document.querySelector(".cart-drawer-modal");
const miniCart = document.querySelector(".cc-popup-modal");
const icons = document.querySelectorAll(".cart-link");

function updateCartDrawerPosition() {
  if (window.innerWidth > 767) {
    const height =
      document.querySelector(".container.container--no-max")?.offsetHeight || 0;
    const cartDrawer = document.querySelector(
      ".cart-drawer-modal.cc-popup.cc-popup--right .cc-popup-modal",
    );
    if (cartDrawer) {
      cartDrawer.style.paddingTop = `${height}px`;
    }
  }
}

function cartClose() {
  if (!miniCartContainer) return;
  miniCartContainer.classList.remove("cc-popup--visible");
  document.body.classList.remove("cc-popup-no-scroll");
  document.body.style.padding = "0";
  const quickbuyContainer = document.querySelector(
    ".minicart-quickbuy-container",
  );
  if (quickbuyContainer && quickbuyContainer.classList.contains("open")) {
    quickbuyContainer.classList.remove("open");
    quickbuyContainer.querySelector(".inner")?.replaceChildren();
  }
}

function cartActive() {
  if (!miniCartContainer) return;
  miniCartContainer.classList.add("cc-popup--visible");
  updateCartDrawerPosition();
}

if (miniCartContainer) {
  window.addEventListener("load", updateCartDrawerPosition);
  window.addEventListener("resize", updateCartDrawerPosition);

  if (window.innerWidth > 767) {
    icons.forEach((icon) => {
      icon.addEventListener("mouseenter", cartActive);
    });
  }
  miniCart?.addEventListener("mouseleave", cartClose);
}
